<template>
    <div>
        <div class="divCenter">
            <h1 style="font-family: rale-reg"> Hi, {{this.name}} </h1>
        </div>
        <div class="Divoverflow">
          <itemlist v-for="(data, idx) in $store.state.items" :key="idx" :data="data">
          </itemlist>
        </div>
        <div>
          <modals ></modals>
        </div>
    </div>
</template>
<script>
import Itemlist from '../components/itemlist.vue';
import modals from '../components/Editmodal.vue';

export default {
  data() {
    return {
      name: localStorage.getItem('name'),
    };
  },
  components: {
    Itemlist,
    modals,
  },
  methods: {
    addForm() {
      this.$router.push('/additem');
    },
  },
  created() {
    this.$store.dispatch('getAllItem');
  },

};
</script>
